<template>
  <div id="login">
    <canvas id="pixie"></canvas>
    <div login-div-conatainer>
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-top: -3%;
          margin-left: 36%;
        "
      >
        <div login-div-wrap-Logo>
          <img src="../assets/imgs/home/WechatIMG12931.png" alt />
        </div>
        <div login-div-wrap>
          <div login-div-wrap-head>普蒂德工作平台</div>
          <div login-div-right-table>
            <div login-div-right-table-cell>
              <div form-line>
                <div form-line-name>
                  <div form-line-name-zh>用户名</div>
                </div>
                <div form-line-input style="display: flex; align-items: center">
                  <input
                    v-model="loginRequest.UserName"
                    autocomplete="new-password"
                    placeholder="请输入您的用户名"
                    @keyup.enter="login"
                  />
                  <span in-u-eyes @click="clearUserName" style="width: 13px">
                    <i class="el-icon-circle-close-outline"></i>
                  </span>
                </div>
              </div>
              <div form-line>
                <div form-line-name>
                  <div form-line-name-zh>密&nbsp;&nbsp;&nbsp;&nbsp;码</div>
                </div>
                <div form-line-input style="display: flex; align-items: center">
                  <input
                    :type="showPwd == false ? 'password' : 'text'"
                    v-model="loginRequest.Password"
                    @keyup.enter="login"
                    placeholder="请输入您的密码"
                  />
                  <span in-u-eyes @click="setShowPwd">
                    <i :class="pwdIcon"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div form-line="btn">
            <el-button type="primary" :loading="loading" @click="login"
              >登录</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestLogin } from "../api/api";
import store from "../utils/storage";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import addWatermark from '@/utils/watermark.js' // 引入水印方法

export default {
  name: "Login",
  data() {
    return {
      loginRequest: {
        UserName: "",
        Password: "",
      },
      showPwd: false,
      pwdIcon: "fa fa-eye-slash",
      loading: false,
    };
  },
  mounted() {
    // 移除水印
    const userInfo = JSON.parse(localStorage.getItem("cur-user-info"));
    if(userInfo && userInfo.showWatermark) {
      addWatermark({
        content: "",
      });
    }
    var curAcc = store.getStore("cur-user-account");
    if (curAcc) {
      this.loginRequest.UserName = curAcc;
    }
    this.$route.query.id && localStorage.setItem('maintainSKU', this.$route.query.id);
  },
  methods: {
    login() {
      NProgress.start();
      this.loading = true;
      requestLogin(this.loginRequest).then((res) => {
        NProgress.done();
        this.loading = false;
        if (res.data.Code !== 1) {
          this.$message.error(res.data.Msg);
          console.log(222)
          return;
        }
        // 从mounted移入 登录成功后清空，在赋值
        store.removeStore("jwt-token");
        store.removeStore("cur-user-info");
        store.removeStore("cur-user-menu");
        store.setStore("jwt-token", res.headers["jwt-token"]);
        res.data.Data.showWatermark =  false; // 是否显示水印  默认不显示
        store.setStore("cur-user-info", JSON.stringify(res.data.Data));
        store.setStore("cur-user-account", this.loginRequest.UserName);

        var ms = store.getMenus();
        store.setStore("cur-user-menu", JSON.stringify(ms));
        this.$router.addRoutes(ms);
        // 有生物样本，跳转到生物样本页面
        const data = localStorage.getItem('maintainSKU');
        if (data) {
          // const router = data.split(',')[0];
          // this.$router.push(router)
          // 扫码跳转优化
          this.$router.push({ path: "/navHome", query: { homeTrue: "true" } });
          setTimeout(() => {
            this.$store.commit('getToMaintainSKU', true);
          }, 500);
        } else {
          this.$router.push({ path: "/navHome", query: { homeTrue: "true" } });
        }
        this.$store.commit("delTags");
      });
    },
    setShowPwd() {
      this.showPwd = !this.showPwd;
      if (this.showPwd) this.pwdIcon = "el-icon-view";
      else this.pwdIcon = "fa fa-eye-slash";
    },
    clearUserName() {
      this.loginRequest.UserName = "";
      store.removeStore("cur-user-account");
    },
  },
};
</script>


<style scoped>
@import "../assets/css/login.css";
</style>


// WEBPACK FOOTER //
// src/components/Login.vue